import type { IconButtonProps } from '@_/ui';
import { PiChatCircleTextLight } from 'react-icons/pi';
import { FormattedNum, IconButton } from '@_/ui';

interface CommentIconButtonProps extends IconButtonProps {
  numComments?: number;
}

export function CommentIconButton({ numComments = 0, ...otherProps }: CommentIconButtonProps) {
  return (
    <IconButton
      ariaLabel="comments"
      icon={<PiChatCircleTextLight />}
      label={numComments ? <FormattedNum compact value={numComments} /> : undefined}
      {...otherProps}
    />
  );
}
